import React from "react";
import { Field, reduxForm } from "redux-form";
import { Form, FormGroup, Label, Alert } from "reactstrap";

import TextInput from "../../fields/TextInput";
import SelectDropdown from "../../fields/SelectDropdown";
import FileUpload from "../../fields/FileUpload";

import * as validations from "../../utils/Validation";

let EditForm = props => {
  const { handleSubmit, mode } = props;
  return (
    <section className="edit-form">
      <Form onSubmit={handleSubmit}>
        <section className="form-section">
          <div className="form-section-header">Personal Details</div>

          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">First Name</Label>
              <Field
                name="first_name"
                component={TextInput}
                placeholder="First Name"
                type="text"
                validate={validations.required}
                autoFocus={true}
              />
            </FormGroup>

            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Last Name</Label>
              <Field
                name="last_name"
                placeholder="Last Name"
                component={TextInput}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div>

          <div className="row">
            <FormGroup className="col-6">
              <Label htmlFor="email">User Group</Label>
              <Field
                name="role"
                component={SelectDropdown}
                options={props.userGroups}
                type="text"
                valueKey="id"
                labelKey="name"
                multi={false}
                className="form-control"
              />
            </FormGroup>
          </div>

          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Email Address</Label>
              <Field
                name="email"
                component={TextInput}
                type="email"
                validate={[validations.required, validations.email]}
              />
            </FormGroup>
          </div>
        </section>

        <section className="form-section">
          <div className="form-section-header">Profile Image</div>

          <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Upload a profile image</Label>
              <Field
                name="profile_picture"
                component={FileUpload}
                multiple={false}
                files={false}
                images={true}
                type="text"
                className="form-control"
              />
            </FormGroup>
          </div>
        </section>

          <section className="form-section">
            <div className="form-section-header">Password</div>

            <div className="row">
              <FormGroup className="col-12 col-sm-6">
                <Label htmlFor="firstName">Set a password</Label>
                <Field
                  name="password"
                  component="input"
                  type="password"
                  className="form-control"
                />
              </FormGroup>

              <FormGroup className="col-12 col-sm-6">
                <Label htmlFor="password_confirmation">Confirm password</Label>
                <Field
                  name="password_confirmation"
                  component="input"
                  type="password"
                  className="form-control"
                />
              </FormGroup>
            </div>
          </section>
      </Form>

      {props.submitFailed && (
        <div className="error-container">
          <Alert color="danger">
            <strong>There are errors in your form.</strong>
            <br />Please check before submitting again.
          </Alert>
        </div>
      )}
    </section>
  );
};

EditForm = reduxForm({
  form: "EditAdminUserForm"
})(EditForm);

export default EditForm;



// WEBPACK FOOTER //
// ./src/system/containers/AdminUsers/Form.jsx